
import React, { useState } from "react";
import styled from "styled-components";
import {components as BusinessCardComponents } from "../../BusinessCard";

//const {actions,components} = BusinessCardAPI;
const {BusinessCardContainer} = BusinessCardComponents;

const Previewer = styled.div`
  height: ${(props) => (props.height ? props.height : "100%")};
  width: ${(props) => (props.width ? props.width : "100%")};
  overflow: auto;
  margin: auto;
  /* width: 100%; */
  &::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar
  {
    width: 6px;
    background-color: #F5F5F5;
  }
  &::-webkit-scrollbar-thumb
  {
    background-color: #4f5963;
  }
`;

export default function BussinesCardPreviewer({previewResolution}) {

  const height = previewResolution ? previewResolution.height : 800;
  const width = previewResolution ? previewResolution.width : 1280;

  return (
    <div>
      <Previewer width={previewResolution.width} height={previewResolution.height}>
        <BusinessCardContainer/>
      </Previewer>
    </div>
  );
}
